import {
  DialogContent,
  type DialogProps,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { BaseButton } from "../BaseButton";
import { BaseIcon } from "../BaseIcons";
import { BaseDialog } from "../base-dialog";

export type BaseActionableDialogProps = Omit<DialogProps, "children"> & {
  title: string;
  actionButtonLabel?: string;
  actionButtonDisabled?: boolean;
  cancelButtonLabel?: string;
  children?: React.ReactNode;
  onClose: () => void;
  onSubmit?: () => void;
};

export const BaseActionableDialog = ({
  title,
  actionButtonLabel,
  actionButtonDisabled,
  cancelButtonLabel,
  children,
  onClose,
  onSubmit,
  ...props
}: BaseActionableDialogProps) => {
  return (
    <BaseDialog {...props} onClose={onClose}>
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6" fontWeight={700}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <BaseIcon htmlColor="grey.400" name="xClose" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack>{children}</Stack>
        <Stack direction="row" spacing={1.5}>
          <BaseButton variant="outlined" onClick={onClose} fullWidth>
            {cancelButtonLabel || "閉じる"}
          </BaseButton>
          {actionButtonLabel && (
            <BaseButton
              type="submit"
              variant="contained"
              onClick={onSubmit}
              fullWidth
              disabled={actionButtonDisabled}
            >
              {actionButtonLabel}
            </BaseButton>
          )}
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
